import { Controller } from "stimulus";

/**
 * Setzt den Placeholder-Text als value des Elements ein wenn es ansonsten leer wäre.
 */
export default class extends Controller {
    connect() {
        this.element.addEventListener("blur", (e) => this.onBlur());
        this.element.addEventListener("focus", (e) => this.onFocus());
        this.onBlur();
    }

    onBlur() {
        if (this.element.value == "") {
            this.element.value = this.default_value;
        }
    }

    onFocus() {
        if (this.element.value == this.default_value) {
            this.element.value = "";
        }
    }

    get default_value() {
        return this.element.getAttribute("placeholder") || "";
    }
}